import { setupForDark } from '@theme';
import classNames from 'classnames';

export default function InputSuccessMessage({ success }: { success: string }) {
  return (
    success && (
      <div
        className={classNames(
          'flex flex-row items-center justify-start gap-xxs',
          'P5R',
          setupForDark('text-success')
        )}
      >
        <div>{success}</div>
      </div>
    )
  );
}
